module.exports = __webpack_public_path__ + "img/wen_sel.b95d7e3e.png";